import { FormInstance } from "antd";
import moment from "moment";
import { calcDates } from "../../../../shared/utils/Dates/calc";

/**
 * 필터 고정값 세팅
 * 필터링 되는 값 없을 때, 주문일시 30일 고정
 */
export const fixFilter = (form: FormInstance<any>) => {
  const now = moment().add(14, "day");
  const monthAgo = calcDates(now, -3);
  form.setFieldsValue({ reservedAt: [monthAgo, now] });
};

/**
 * 값 없는 formdata 제거
 * @param formdata
 * @returns
 */
export const uniqFilter = (formdata: any) => {
  return (
    Object.fromEntries(
      Object.entries(formdata).filter(
        ([k, v]) => v !== undefined && v !== null && v !== ""
      )
    ) || {}
  );
};
